/**
 * Склоняет слово в зависимочти от числа
 * @param {Number} value — числительное, по которому будет склоняться слово
 * @param {Array} words — 3 варианта склонения слова, пример: ['новость', 'новости', 'новостей']
 */
export default function declineWordOfNum(value, words) {
    const twoDigitValue = Math.abs(value) % 100;
    const simpleValue = twoDigitValue % 10;
    if (twoDigitValue > 10 && twoDigitValue < 20) return words[2];
    if (simpleValue > 1 && simpleValue < 5) return words[1];
    if (simpleValue === 1) return words[0];
    return words[2];
}
